export default __webpack_public_path__ + "static/media/trackerApp.9c5fef0f.png";